import { Component, OnInit } from '@angular/core';

import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-e-book',
  templateUrl: './e-book.component.html',
  styleUrls: ['./e-book.component.css']
})
export class EBookComponent implements OnInit {

  Setting: any = [];
  constructor(private homepageService: HomepageService) { }
  ngOnInit() {
  	this.getSetting();
  }

  getSetting() {
   this.Setting = this.homepageService.getUpdatedConfig();
  }


  
}
